import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// Lodash
import _get from "lodash/get";

// Components
import LoginForm from "./components/loginForm";
import { Title } from "../../components/atoms/typography";
import Logo from "../../assets/images/logo.webp";
import { toast } from "../../components/atoms/toaster";

// Redux
import { addUser } from "./redux/loginSlice";

// Constants
import { EMPTY_OBJECT } from "../../constants/base.constants";

// Services
import authService from "../../services/authService";

// Styles
import styles from "./login.module.scss";
import { useTheme } from "../../theme/themeCreate";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [signingIn, setIsSigningIn] = useState(false);
   const { isDarkTheme, } = useTheme();
  const handleSubmit = ({ userEmail, userPassword }) => {
    setIsSigningIn(true);
    authService
      .login({ userEmail, userPassword })
      .then((response) => {
        const token = _get(response, "token");
        const userDetails = _get(response, "admin", EMPTY_OBJECT);
        dispatch(addUser(userDetails));
        localStorage.setItem("signedIn", "true");
        localStorage.setItem("token", token);
        window.location.replace(`${window.location.origin}`);
        // navigate("/dashboard");
      })
      .catch(() => {
        setIsSigningIn(false);
        toast.error("Login Failed: Invalid credentials");
      });
  };

  return (
    <div className={styles.container} style={{backgroundColor:isDarkTheme?'#000':'#fff'}} >
      <div className={styles.content} >
        <div className={styles.title}>
          <img className={styles.logo} src={Logo}></img>
          <Title className={styles.titleText}>Sign in to your account</Title>
        </div>
        <div className={styles.loginForm} style={{backgroundColor:isDarkTheme?'#000':'#fff'}}>
          <LoginForm onSubmit={handleSubmit} loading={signingIn} />
        </div>
      </div>
    </div>
  );
}

export default Login;
